import { render, staticRenderFns } from "./thirdLogoRow.vue?vue&type=template&id=1ba3fd6b&"
import script from "./thirdLogoRow.vue?vue&type=script&lang=js&"
export * from "./thirdLogoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports